<div class="list-wrapper">
    <div class="list-header">
        <div class="list-title">
            {{title}}
        </div>
        <div class="search">
            <input type="text" (input)="onQueryInput($any($event.target).value)" />
            <mat-icon>search</mat-icon>
        </div>
    </div>
    <div class="list-body">
        <ng-content></ng-content>
    </div>
</div>